import "./MessageDialogTest.scss";
import { FunctionComponent, useEffect, useState } from "react";
import { MessageDialogProps } from "./IMessageDialogTest";
import ButtonField from "../Button/ButtonField";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../Redux/Store/Hooks";
import { listExamsubmitPractice } from "../../Redux/Slices/ExamAnswerPractice/ListExamsubmitPracticeSlice";
import {
  clearlistEvaluationPracticewritingExam,
  listEvaluationPracticewritingExam,
} from "../../Redux/Slices/PracticeExam/ListEvaluationPracticewritingExamSlice";
import { listEvaluation } from "../../Redux/Slices/Exam/ListEvaluationSlice";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Stack,
  Button,
  Box,
} from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import { ReactComponent as Tick } from "../../Assets/Images/check-circle.svg";
import FlagOutlinedIcon from "@mui/icons-material/FlagOutlined";

const MessageDialogTest: FunctionComponent<MessageDialogProps> = (props) => {
  const {
    open,
    setOpen,
    messageableName,
    messageheading,
    valueofdata,
    condition,
    questioncount,
    questioncountflag,
    listcountflag,
    listcount,
    writingSentence,
    Question_id,
    setIsSubmitted,
    setIspopup,
  } = props;

  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const final: any = valueofdata;

  const { data: EvaluationPracticewritingExam } = useAppSelector(
    (state) => state.ListEvaluationPracticewritingExamSlice
  );
  const { data: listExamsubmitSlice } = useAppSelector(
    (state) => state.ListExamsubmitPracticeSlice
  );
  const Add: any = listExamsubmitSlice?.data;

  useEffect(() => {
    if (EvaluationPracticewritingExam?.status && condition) {
      navigate("/examresultpractice", {
        state: {
          id: final,
          type: "writing",
          showSubmitAlert: true,
          evaluationData: EvaluationPracticewritingExam,
        },
      });
    }
  }, [EvaluationPracticewritingExam, navigate, final, condition]);

  useEffect(() => {
    return () => {
      dispatch(clearlistEvaluationPracticewritingExam());
    };
  }, [dispatch]);

  const unansweredList: any[] = Array.isArray(listcount) ? listcount : [];
  const flaggedList: any[] = Array.isArray(listcountflag) ? listcountflag : [];

  const unansweredCount =
    typeof questioncount === "number" ? questioncount : unansweredList.length;
  const flaggedCount =
    typeof questioncountflag === "number"
      ? questioncountflag
      : flaggedList.length;

  const getEvaluationPayload = () => {
    if (!condition) {
      // For non-writing exams
      return {
        type: "regular",
        payload: {
          student_test_id: Add?.student_exam_id,
        },
      };
    } else {
      // For writing exams
      return {
        type: "writing",
        payload: {
          sentence: writingSentence,
          student_test_id: final,
          question_id: Number(Question_id),
        },
      };
    }
  };

  return (
    <Dialog
      open={!!open}
      onClose={() => setOpen && setOpen(false)}
      maxWidth="xs"
      fullWidth
      aria-labelledby="message-dialog-title"
      PaperProps={{
        sx: {
          borderRadius: 2.5,
          p: 0,
          backgroundColor: "#ffffff",
          boxShadow: "0 8px 30px rgba(2,6,23,0.12)",
        },
      }}
      BackdropProps={{
        sx: {
          backgroundColor: "rgba(255,255,255,0.6)",
          backdropFilter: "blur(4px)",
        },
      }}
    >
      {/* Title */}
      <DialogTitle id="message-dialog-title" sx={{ px: 3, py: 2 }}>
        <Box display="flex" alignItems="center" gap={1}>
          <InfoIcon sx={{ fontSize: 28, color: "#f97316" }} />
          <Typography variant="h6" fontWeight={700}>
            {messageheading}
          </Typography>
        </Box>
      </DialogTitle>

      {/* Content */}
      <DialogContent sx={{ px: 3, pt: 0, pb: 2 }}>
        {condition ? (
          <Typography sx={{ fontSize: "15px", color: "#64748b" }}>
            Are you sure you want to submit?
          </Typography>
        ) : (
          <>
            {/* Main message */}
            <Typography
              component="div"
              sx={{ color: "#64748b", fontSize: "15px", mb: 2 }}
            >
              {messageableName}
            </Typography>

            {/* Unanswered */}
            <Stack spacing={1} mb={2}>
              <Stack direction="row" alignItems="center" spacing={1}>
                <InfoIcon
                  sx={{ color: "#d19f00", height: "25px", width: "25px" }}
                />
                <Typography fontWeight={600} sx={{ fontSize: "16px" }}>
                  Unanswered Questions
                </Typography>
              </Stack>

              <Typography sx={{ color: "#d19f00", fontSize: "15px" }}>
                You have {unansweredCount} unanswered question
                {unansweredCount !== 1 ? "s" : ""}.
              </Typography>

              <Stack
                direction="row"
                sx={{ mt: 1, flexWrap: "wrap", gap: "10px" }}
              >
                {unansweredList.map((num: any) => (
                  <Box
                    key={String(num)}
                    sx={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      backgroundColor: "rgb(254 249 195)",
                      color: "#854d0e",
                      border: "1px solid #fef9c3",
                      borderRadius: "5px",
                      padding: "2px 10px",
                      fontSize: "13px",
                      height: "26px",
                      lineHeight: 1,
                    }}
                  >
                    Question {num}
                  </Box>
                ))}
              </Stack>
            </Stack>

            {/* Flagged */}
            <Stack spacing={1}>
              {/* Title row */}
              <Stack direction="row" alignItems="center" spacing={1}>
                {flaggedCount > 0 ? (
                  <FlagOutlinedIcon
                    sx={{ color: "#f97316", height: "25px", width: "25px" }}
                  />
                ) : (
                  <Tick
                    style={{
                      color: "#16a34a",
                      height: "25px",
                      width: "25px",
                    }}
                  />
                )}
                <Typography fontWeight={600} sx={{ fontSize: "16px" }}>
                  Flagged Questions
                </Typography>
              </Stack>

              {/* Description */}
              <Typography
                sx={{
                  fontSize: "16px",
                  color: flaggedCount > 0 ? "#000" : "#16a34a",
                }}
              >
                {flaggedCount > 0
                  ? "Flagged Questions"
                  : "No questions have been flagged."}
              </Typography>

              {/* Flagged Question Pills */}
              <Stack
                direction="row"
                sx={{ mt: 1, flexWrap: "wrap", gap: "10px" }}
              >
                {flaggedList.map((num: any) => (
                  <Box
                    key={String(num)}
                    sx={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      backgroundColor: "#ffedd5", // light orange background
                      color: "#9a3412", // dark orange text
                      border: "1px solid #ffedd5", // orange border
                      borderRadius: "5px", // pill shape
                      padding: "2px 10px",
                      fontSize: "13px",
                      height: "26px",
                      lineHeight: 1,
                    }}
                  >
                    Question {num}
                  </Box>
                ))}
              </Stack>
            </Stack>
          </>
        )}
      </DialogContent>

      {/* Actions */}
      <DialogActions sx={{ px: 3, pb: 2, pt: 0 }}>
        <ButtonField
          className="bacKtotest"
          onClick={() => {
            setOpen?.(false);
            setIsSubmitted?.(false);
          }}
        >
          Return to Test
        </ButtonField>

        <ButtonField
          className="submitAnyway-button"
          onClick={() => {
            const evaluationPayload = getEvaluationPayload();

            
            navigate("/examresultpractice", {
              state: {
                id: final,
                type: condition ? "writing" : "regular",
                showSubmitAlert: true,
                evaluationPayload: evaluationPayload, 
                needsEvaluation: true, 
              },
            });

            setIsSubmitted?.(false);
            setIspopup?.(true);
          }}
        >
          {unansweredCount === 0 && flaggedCount === 0
            ? "Submit"
            : "Submit Anyway"}
        </ButtonField>
      </DialogActions>
    </Dialog>
  );
};

export default MessageDialogTest;
